exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1416b284] .el-dialog__body{max-height:580px;overflow:auto}\n", ""]);

// exports
